if (!customElements.get('mmx-size-chart-modal')) {
  customElements.define(
    'mmx-size-chart-modal',
    class MmxSizeChartModal extends HTMLElement {
      constructor() {
        super();

        this.querySelector('[id^="ModalClose-"]')?.addEventListener('click', this.hide.bind(this));
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
      }

      show(opener) {
        this.openedBy = opener;
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        trapFocus(this, this.querySelector('[role="dialog"]'));
      }

      hide() {
        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
      }
    }
  );
}
